import { BREEDER_REFUND_POLICY } from 'dpl/breeder_account/utils/constants';

const DEPOSIT_SECURES_TEXT = {
  specific_puppy: 'a specific puppy',
  litter_spot: 'your spot in a litter',
  waitlist_spot: 'your spot on the waitlist'
};

const FINAL_PAYMENT_TIMING_TEXT = {
  before_pickup: 'before pickup',
  at_pickup: 'at pickup'
};

export function ensureCurrencyIsPresent(price) {
  if (price == null || Number.isNaN(price)) {
    return '';
  }

  return price.toString().startsWith('$') ? price : `$${price}`;
}

// dogName is only used for a specific_puppy deposit; omit it (e.g. in the
// deposit terms modal, which never names a dog) to get the generic clause.
/**
 * @param {string | null} depositSecures
 * @param {string | null} [dogName]
 */
export function getDepositSecuresText(depositSecures, dogName = null) {
  if (!depositSecures) {
    return null;
  }

  if (depositSecures === 'specific_puppy' && dogName) {
    return dogName;
  }

  return DEPOSIT_SECURES_TEXT[depositSecures] || null;
}

export function getFinalPaymentTimingText(finalPaymentTiming) {
  return FINAL_PAYMENT_TIMING_TEXT[finalPaymentTiming] || null;
}

// The legacy 'other' policy has no adjective form, so it's treated as unset.
export function getDepositRefundPolicyAdjective(depositRefundPolicy) {
  return depositRefundPolicy === BREEDER_REFUND_POLICY.REFUNDABLE ||
    depositRefundPolicy === BREEDER_REFUND_POLICY.NON_REFUNDABLE
    ? depositRefundPolicy
    : null;
}

function formatListItemAmount(amount) {
  return amount
    ? `${ensureCurrencyIsPresent(parseFloat(amount).toFixed(2))} `
    : '';
}

export function getPaymentAndSupportListItems(amount) {
  return [
    `Your ${formatListItemAmount(amount)}payment is protected by Good Dog Payment Protection, and our team will step in if something goes wrong`,
    'Expert support from specialists who work with breeders every day, guided by veterinarians',
    'Puppy Guidance, with timely tips and articles from pickup through the teenage months'
  ];
}

export function getBasicProtectionAndSupportListItems() {
  return [
    'No Payment Protection. Our team can’t step in if something goes wrong',
    'No access to expert support or Puppy Guidance',
    'Designed for payments between trusted friends and family'
  ];
}

export function isFormattedAmountZero(formattedAmount) {
  if (!formattedAmount) {
    return true;
  }

  const numericValue = parseFloat(
    formattedAmount.toString().replace(/[$,\s]/g, '')
  );

  if (Number.isNaN(numericValue)) {
    return true;
  }

  return numericValue === 0;
}
